import React from 'react';
import PackagesPage from 'components/PackagesPage';

const PrimePage = () => {
  return (
    <div>
      <PackagesPage
        category={'prime'}
        messageID={'pages.pack.primePage'}
        descriptionID={'pages.pack.primePage.description'}
      />
    </div>
  );
};

export default PrimePage;
